import { ReactNode } from 'react';

// Constants
export const FEATURE_FLAG_CACHE_TIME = 1000 * 60 * 60 * 24; // 24 hours

export enum AccessLevelOptions {
  COURSE = 'course',
  SECTION = 'section',
  ORGANIZATION = 'organization',
  DISTRICT = 'district',
  USER = 'user',
}

export type AccessLevel = keyof typeof AccessLevelOptions;

export interface AccessParams {
  courseId?: string;
  sectionId?: string;
  organizationId?: string;
  districtId?: string;
  userId?: string;
}

export interface FeatureFlagConfig {
  featureName: string;
  suspense?: boolean;
  allowedRoles?: string[];
}

export interface FeatureEnabledBuilderProps extends FeatureFlagConfig {
  children?: ReactNode;
}

export interface AccessMetadata {
  message: string;
  feature: {
    id: number;
    name: string;
    slug: string;
  };
  has_access: boolean;
}
export interface FeatureFlagAccessResponse {
  level: AccessLevel;
  user_access: {
    [key: string]: AccessMetadata;
  };
}
